import { api } from '@/f1/service';
import Language from './language';
import AgentItem from '@/f1/views/integrity/DashboardItem.i18n';
import moment from 'moment-timezone';
import { VclFacebook } from 'vue-content-loading';
import _ from 'lodash';
import AnimatedNumber from "animated-number-vue";

//restful api
//import { wmds as ws } from '@/f1/service/api'
//import { wsfinder as wf } form '@/f1/service/api'

import i18n_data from '@/component/i18n_data';

export default {
  components : {
    AnimatedNumber,
    Language,
    VclFacebook,
    AgentItem,
  },
  data: () => {
    return {
      loading : false,
      th : undefined,
      agents : [],
      count : 0,
      info : {
        from : { alive : 0, deleted : 0, total : 0 },
        server : { alive : 0, deleted : 0 },
        domain : { alive : 0, deleted : 0 },
        detect : { day : 0, week : 0, month : 0 },
      }

    }
  },
  computed : { chartData() { return this.chartOptions; } },
  methods: {
    value_comma(v) {
      // return v;
      if(isNaN(v)) { return 0 }
      return v ?(Number(v).toFixed(0) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0
    },
    default_info() { return { scan_count : 0, detect_count : 0, isolation_count : 0, total : 0 } },
    catch_msg(e) { console.error(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : (e.data.message ? e.data.message : e.statusText)); },
    async load() {
      this.loading = true

      let today = moment();
      try {
        let rs = await api.wsfinder.WSFinder_Call("dashboard", "month.forgery");
        //let rs = await wf.dashboard.monthForgery();
        for (let i = 0; i < rs.body.data.length; i++) {
          const r = rs.body.data[i];

          let rdate = moment(r.date);

          if(rdate.month() == today.month()) {
            this.info.detect.month += r.total;
          }
          if(moment.duration(rdate.diff(today)).asDays() > -8) {
            this.info.detect.week += r.total;
          }
          if(moment.duration(rdate.diff(today)).asDays() > -1) {
            this.info.detect.day += r.total;
          }
        }
      } catch (e) {
        console.log(e)
        this.catch_msg(e)
      }


      try {
        let rs = await api.wmds.WMDS_Call("dashboard", "month.forgery")
        //let rs = await ws.dashboard.monthForgery()
        for (let i = 0; i < rs.body.data.length; i++) {
          const r = rs.body.data[i];
          let rdate = moment(r.date);

          if(rdate.month() == today.month()) {
            this.info.detect.month += r.total;
          }
          if(moment.duration(rdate.diff(today)).asDays() > -8) {
            this.info.detect.week += r.total;
          }
          if(moment.duration(rdate.diff(today)).asDays() > -1) {
            this.info.detect.day += r.total;
          }
        }
      } catch (e) {
        console.log(e);
        this.catch_msg(e)
      }

      try {
        let rs_wsfinder = await api.wsfinder.WSFinder_Call("dashboard", "agent.forgery")
        //let rs_wsfinder = await wf.dashboard.agentForgery()
        this.info.server = { alive : 0, deleted : 0 };
        if(rs_wsfinder.is_error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }

        this.info.server.alive = rs_wsfinder.body.data.total - (rs_wsfinder.body.data.deleted ? rs_wsfinder.body.data.deleted : 0)
        this.info.server.deleted = (rs_wsfinder.body.data.deleted ? rs_wsfinder.body.data.deleted : 0)

        let rs_wmds = await api.wmds.WMDS_Call("dashboard", "agent.forgery")
        //let rs_wmds = await ws.dashboard.agentForgery()
        this.info.domain = { alive : 0, deleted : 0 };
        if(rs_wmds.is_error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }

        this.info.domain.alive  = rs_wmds.body.data.total - (rs_wmds.body.data.deleted ? rs_wmds.body.data.deleted : 0)
        this.info.domain.deleted = (rs_wmds.body.data.deleted ? rs_wmds.body.data.deleted : 0)

      } catch (e) { console.error(e) }

      this.agents = []

      // wsfinder
      this.count = 0
      try {

        let rs = await api.wsfinder.WSFinder_Call("agent", "list", { offset : 0, limit :  100, sort : [ { name : "id", op : "desc" } ] });
        //let rs = await wf.agent.list({ offset : 0, limit :  100, sort : [ { name : "id", op : "desc" } ] });
        if(rs.is_error) { return this.$toastr.w(`${i18n_data._i18n_error.wmds_load[this.i18n]}`) }
        this.count += rs.total;
        let wsfinder = rs.body

        _.forEach(wsfinder, async (r, index) => {

          function info(id) {
            return new Promise(async (resolve, reject) => {
              let rs = await api.wsfinder.WSFinder_Call('forgery', 'detail', { type : 'WSFinder', id : id });
              //let rs = await wf.forgery.detail({ type : 'WSFinder', id : id })
              if(rs.is_error) {
                this.$toast.w(`${i18n_data._i18n_error.load_failed[this.i18n]}`)
                resolve({})
              }
              resolve(rs.body)
            })
          }

          let result = await info(r.id)
          this.info.from.total += 1
          if(result.is_alive) { this.info.from.alive += 1; }
          // console.log(r.name, 'wsfinder', index, this.info.from.total)

          // if(!result.is_alive) { return console.log('not using this agent to forgery', r.nickname) }

          function week() {
            return new Promise(async (resolve, reject) => {
              try {

              let week = await api.wsfinder.WSFinder_Call('dashboard', 'week.forgery', { agent_id : r.id });
              //let week = await wf.dashboard.weekForgery({ agent_id : r.id });
                if(week.is_error) {
                  this.$toast.w(`${i18n_data._i18n_error.load_failed[this.i18n]}`)
                  resolve([])
                }
                resolve(week.body)

            } catch (e) { resolve([]); console.log(e) }})
          }

          let rs_week = await week()
          let total_detect = rs_week.is_error ? 0 : rs_week.total
          // console.log('wsfinder total_detect', rs_week)

          // wsfinder[index] = Object.assign({}, r, result, { type : 'wsfinder', total_detect : total_detect })
          this.agents.push(Object.assign({}, r, result, { type : 'WSFinder', total_detect : total_detect, is_configured : result && result.snapshot && result.watching }))
        })

      } catch(e) { console.log(e) }


      // wmds
      try {
        let rs = await api.wmds.WMDS_Call("site", "list", { offset : 0, limit :  100, sort : [ { name : "id", op : "desc" } ] });
        //let rs = await ws.site.list({ offset : 0, limit :  100, sort : [ { name : "id", op : "desc" } ] });
        if(rs.is_error) { return this.$toastr.w(`${i18n_data._i18n_error.wmds_load[this.i18n]}`) }
        this.count += rs.total;
        let wmds = rs.body

        _.forEach(wmds, async (r, index) => {
          function info(id) {
            return new Promise(async (resolve, reject) => {
              try {
                let rs = await api.wmds.WMDS_Call('forgery', 'detail', { type : 'WMDS', site_id : id });
                //let rs = await ws.forgery.detail({ type : 'WMDS', site_id : id });
                if(rs.is_error) {
                  this.$toast.w(`${i18n_data._i18n_error.load_failed[this.i18n]}`)
                  resolve({})
                }
                resolve(rs.body)
              } catch (e) {
                resolve({})
                console.log(e)
              }
            })
          }

          let result = await info(r.id)
          this.info.from.total += 1
          if(result.is_alive) { this.info.from.alive += 1 }
          // console.log(r.name, 'wmds', index, this.info.from.total, result.is_alive)
          // if(!result.is_alive) { return console.log('not using this agent to forgery', r.name) }

          function week() {
            return new Promise(async (resolve, reject) => {
              try {
                let week = await api.wmds.WMDS_Call('dashboard', 'week.forgery', { site_id : r.id });
                //let week = await ws.dashboard.weekForgery({ site_id : r.id });
                if(week.is_error) {
                  this.$toast.w(`${i18n_data._i18n_error.load_failed[this.i18n]}`)
                  resolve([])
                }
                resolve(week.body)

              } catch (e) { resolve([]); console.log(e); }
            })
          }

          let rs_week = await week()
          let total_detect = rs_week.is_error ? 0 : rs_week.total
          // console.log('wmds total_detect', rs_week)

          this.agents.push(Object.assign({}, r, result, { type : 'WMDS', total_detect : total_detect,  is_configured : result && result.snapshot && result.snapshot.length > 0 }))
        })
        // this.agents = _.concat([], this.agents, wmds)

      } catch(e) { console.log(e) }

      // 데이터 업데이트
      this.loading = false
      // _.forEach(this.$refs, x => { try { console.log(x._uid, 'start') && x && x.play && x.indexOf('_check_') > -1 && x.play() } catch (e) { console.log(e); }})

      return

    },
  },
  mounted () {
    console.log('WFDetect dashboard.vue mounted');
    this.load();
  },
  destroyed () {
    console.log('WFDetect dashboard.vue destroyed');
  },
  watch : {
    '$route' (to, from) {
      this.load(to.params.id, from);
    },
    agents() {
      console.log('changed')
    }
  }
}
